import clsx from "clsx";
import { IconProps } from "@/types/icons.ts";
import { createColorClasses } from "@/theme/colors";

export const StructureDiagnose = ({
  width = 16,
  height = 17,
  className,
  color,
  decorative = false,
  ariaLabel = "StructureDiagnose",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      stroke="currentColor"
      viewBox="0 0 16 17"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        strokeWidth="0.3"
        d="M6.52 10.568a4.541 4.541 0 0 1-3.223-1.335 4.54 4.54 0 0 1-1.29-2.572.79.79 0 1 1 1.563-.222A2.995 2.995 0 0 0 6.52 8.99 2.995 2.995 0 0 0 9.47 6.44a.795.795 0 0 1 .781-.68.788.788 0 0 1 .781.902 4.53 4.53 0 0 1-1.289 2.572 4.54 4.54 0 0 1-3.223 1.335ZM2.79 6.26a.28.28 0 0 0-.218.1.29.29 0 0 0-.068.23A4.03 4.03 0 0 0 3.65 8.88a4.04 4.04 0 0 0 2.87 1.188A4.03 4.03 0 0 0 9.39 8.879a4.04 4.04 0 0 0 1.147-2.289.28.28 0 0 0-.068-.23.289.289 0 0 0-.505.151 3.482 3.482 0 0 1-6.889 0 .29.29 0 0 0-.286-.251Z"
      />
      <path
        strokeWidth="0.3"
        d="M10.294 6.26a.25.25 0 0 1-.25-.25V1.852a.66.66 0 0 0-.658-.658h-.3a.25.25 0 1 1 0-.5h.3c.638 0 1.158.52 1.158 1.158v4.156a.25.25 0 0 1-.25.25ZM4.409 1.74H3.96a.25.25 0 0 1-.25-.25V.4a.25.25 0 0 1 .25-.25h.448a.795.795 0 0 1 0 1.59Zm-.198-.5h.198a.295.295 0 0 0 0-.59H4.21z"
      />
      <path
        strokeWidth="0.3"
        d="M9.086 1.74h-.448a.795.795 0 0 1 0-1.59h.448a.25.25 0 0 1 .25.25v1.09a.25.25 0 0 1-.25.25ZM8.638.65a.295.295 0 0 0 0 .59h.198V.65zM2.75 6.26a.25.25 0 0 1-.25-.25V1.852c0-.639.52-1.158 1.157-1.158h.3a.25.25 0 1 1 0 .5h-.3A.66.66 0 0 0 3 1.853v4.156a.25.25 0 0 1-.25.25ZM11.66 16.15a1.28 1.28 0 0 1-1.278-1.277v-1.506a.778.778 0 0 0-1.554 0v1.506c0 .704-.573 1.277-1.277 1.277a1.28 1.28 0 0 1-1.278-1.277v-4.557a.25.25 0 1 1 .5 0v4.557a.778.778 0 0 0 1.555 0v-1.506c0-.704.573-1.277 1.277-1.277s1.277.573 1.277 1.277v1.506a.778.778 0 0 0 1.555 0v-4.387a.25.25 0 1 1 .5 0v4.387c0 .704-.573 1.277-1.277 1.277Z"
      />
      <path
        strokeWidth="0.3"
        d="M12.689 10.738a1.01 1.01 0 0 1 0-2.02 1.01 1.01 0 0 1 0 2.02Zm0-1.52a.51.51 0 1 0 .001 1.02.51.51 0 0 0-.001-1.02Z"
      />
    </svg>
  );
};
